// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"formWrap--2r6qN","formItem":"formItem--gk2hO","formItemCon":"formItemCon--2DUMF","btnWrap":"btnWrap--39E4f","btnInner":"btnInner--37JSI","regBtn":"regBtn--CKZMj"};